import script from "./Corporate.vue?vue&type=script&setup=true&lang=js"
export * from "./Corporate.vue?vue&type=script&setup=true&lang=js"

import "./Corporate.vue?vue&type=style&index=0&id=cb061220&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb061220"]])

export default __exports__